import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

const useFetchData = (fetchFunction, id, initialFormState, lang) => {
    const [formStateById, setFormStateById] = useState(initialFormState);
    const [fetching, setIsfetching] = useState(false);
    const [fetchError, setFetchError] = useState(null);
    const model = 'servicepoint_type'
    useEffect(() => {
        const fetchData = async () => {
            setIsfetching(true);
            try {
                const response = await fetchFunction(id);
                const mainDataObject = response.data[model];
                const updatedFormState = {
                    id: mainDataObject.id,
                    name: mainDataObject.name
                }
                setFormStateById(updatedFormState)
            } catch (err) {
                toast.error(`Error: ${err.message}`);
                setFetchError(err.message);
            } finally {
                setIsfetching(false);
            }
        };
        fetchData();
    }, []);
    return { formStateById, setFormStateById, fetching, fetchError };
};
export default useFetchData;
